import { MeteoHomeContext } from 'pages/meteo/[type]/[locality]';
import { useContext, useMemo } from 'react';
import { MeteoHomeTabs } from '@meteo/business/Meteo.types';
import { getCityInfos } from '@meteo/business/meteo.utils';
import { useCityCanonical } from '@meteo/business/useCityCanonical';
import { StandardCity } from '@meteo/types';
import { ATLevel2, PlcTagProps } from 'features/tagPlan/business/TagPlan.types';

function useMetag(city?: StandardCity, activeTab?: MeteoHomeTabs) {
  const {
    city: { isValidating: isCityValidating },
  } = useContext(MeteoHomeContext);
  const metaOptions = city ? getCityInfos(city) : undefined;

  const canonical = useCityCanonical(city);

  const tagProps: PlcTagProps = useMemo(
    () => ({
      isDataLoading: isCityValidating,
      level2: ATLevel2.Meteo,
      tagPageNameI18nArray: [
        'meteo.tag.title',
        // eslint-disable-next-line no-nested-ternary
        activeTab === MeteoHomeTabs.FifteenDays
          ? 'meteo.tag.15days'
          : activeTab === MeteoHomeTabs.ThirtySixHours
            ? 'meteo.tag.36hours'
            : 'meteo.tag.heure-par-heure',
      ],
    }),
    [activeTab]
  );

  const meta = metaOptions
    ? {
        canonical,
        metaDescI18n: 'meteo.home.city.meta-desc',
        metaDescOptions: metaOptions,
        metaTitleI18n: 'meteo.home.city.meta-title',
        metaTitleOptions: metaOptions,
      }
    : {
        metaDescI18n: 'meteo.home.meta-desc',
        metaTitleI18n: 'meteo.home.meta-title',
      };

  return { meta, metaOptions, tagProps };
}

export { useMetag };
